import styles from '../../styles/modules/services/ServicesListItem.module.scss';

const ServicesListItem = ({ text, details }) => {
  return (
    <div className={styles.item}>
      <div className={styles.title}>{text}</div>
      <div className={styles.captions}>
        {details.map((value, index) => (
          <span
            style={{
              textDecoration: value.type === 'crossed' ? 'line-through' : '',
              fontWeight: value.type === 'accent' ? 600 : value.type === 'crossed' ? 300 : 400,
              color: value.type === 'accent' ? '#fb5f5f' : '',
              opacity: value.type === 'crossed' ? 0.8 : 1
            }}
            key={index}
          >
            {value.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ServicesListItem;
